/**
 * 🔴 P5.3 (CLAUDE.md §7 · `docs/scenarios/financial-principles.md`) — thuật ngữ kế toán KHÔNG lọt lên chữ người dùng đọc. MỘT nguồn:
 * lưới tự khám phá `apps/api/src/modules/ai-doer/no-accounting-jargon.invariants.spec.ts` (Sổ · mã nguồn trợ lý · ARB mobile) và
 * `proseProblems` (kiểm câu theo thuộc tính, AI-SMOOTH-3) cùng đọc bảng này. File CHỈ chứa bảng (máy quét P5.3 miễn đúng file này — khoá của
 * bảng là từ cấm); câu người dùng đọc không được đặt ở đây. Tập khoá chỉ được TĂNG (`accounting-jargon.test.ts`). Giá trị = cách nói cho người dùng
 * (thông điệp đỏ tự chỉ đường sửa).
 *
 * ⚠️ "đối chiếu" CỐ Ý vắng: §3.7 đòi đúng trạng thái trung thực *"Đã chuyển – chưa đối chiếu"* — cấm nó là mâu thuẫn với một luật tiền.
 */
export const ACCOUNTING_JARGON: Readonly<Record<string, string>> = Object.freeze({
  settlement: "Ai trả ai",
  reconciliation: "Chốt sổ",
  reconcile: "Chốt sổ",
  netting: "Gộp nợ cho gọn",
  forgiven: "Đã được cho qua",
  debit: "Bạn còn nợ",
  credit: "Nhóm nợ bạn",
  ledger: "sổ quỹ",
  "bút toán": "khoản đã ghi sổ / dòng điều chỉnh",
  "sổ cái": "sổ quỹ",
  "ghi nợ": "Bạn còn nợ",
  "ghi có": "Nhóm nợ bạn",
  "đối soát": "Chốt sổ",
  "hạch toán": "ghi vào sổ quỹ",
  "tất toán": "trả hết",
  "cấn trừ": "Gộp nợ cho gọn",
});

const JARGON_RES = Object.entries(ACCOUNTING_JARGON).map(([term]) => ({
  term,
  // Biên chữ Unicode: "credit" không khớp trong "discredited"; "ghi có" không khớp "ghi công".
  re: new RegExp(`(?<![\\p{L}\\p{N}])${term}(?![\\p{L}\\p{N}])`, "iu"),
}));

/** Các thuật ngữ kế toán (khoá của `ACCOUNTING_JARGON`) có trong câu, theo thứ tự bảng. */
export function accountingJargonIn(text: string): string[] {
  return JARGON_RES.filter((t) => t.re.test(text)).map((t) => t.term);
}
